import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-generar-carta',
  templateUrl: './generar-carta.component.html',
  styleUrls: ['./generar-carta.component.scss']
})
export class GenerarCartaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
